import { FBWorkspaceState } from '..';
import { checkIsDocumentMPIOutput } from '../../documentRevision/helpers/checkDocumentGroup';
import { DEVIATION_HIDE_KEY } from './FBDeviationProcedure.constants';

interface DeviationStepView {
  // the "Show/Hide Deviation Changes" switch goes above this component
  toggleAnchor?: string
  // components the deviation added, marked green while changes are shown
  highlighted: Set<string>
}

/**
 * What an LHR step's schema renderer shows for its deviation. Computed once per render (not per component),
 * and undefined for every other document, before the schema is even read.
 */
export const getDeviationStepView = (ws?: FBWorkspaceState): DeviationStepView | undefined => {
  if (!checkIsDocumentMPIOutput(ws?.document?.document?.documentType?.groupOptions)) { return; }
  if (!ws?.isOutput && !['preview', 'formPreview'].includes(ws?.mode ?? '')) { return; }

  // The BE lists them on the step's procedure, or on "Completed By" when the MPI has no procedure
  const holder = ws?.schema?.find((item) => item.type === 'mpiprocedure')
    ?? ws?.schema?.find((item) => item.type === 'lhrStepApprovals');
  const added = (holder?.editorConfig as { deviation?: { addedComponents?: string[] } } | undefined)
    ?.deviation?.addedComponents ?? [];
  if (!added.length) { return; }

  // A deviated procedure shows its own switch (FBMPIProcedure)
  const hasDeviatedProcedure = ws?.schema?.some((item) =>
    !item.deleted && item.type === 'mpiprocedure' && Boolean(item.editorConfig?.deviation));
  return {
    toggleAnchor: hasDeviatedProcedure ? undefined : added[0],
    highlighted: new Set(ws?.formInputSync.get(DEVIATION_HIDE_KEY) ? [] : added),
  };
};
